const externalLinks = {
  login: isDev ? "/dev_login/index.html" : "/login",
};

export default externalLinks;
